<template>
<div>
    <div
                class=" row collapse border-1 border-top  pt-2 mt-2"
                :class="{ show: isAdvanceOpt }"
                id="collapse-Example"
                style="cursor: pointer"
      >

<div class="d-flex flex-wrap">
              
<div  v-for="(data,index) of advanceOption" :key="index" class="advancedData">
                  <v-switch
                  
                    v-model="data.value"
                    :label=data.label
                    :color="data.value ? '#ff4d00' : 'white'"
                    class="me-4"
                    @change="sentAdvance(data,index)"
                  ></v-switch>
                  
</div>

<!-- <div class=" dropdownSection mt-2" style="width:130px">
   <v-menu
                      v-model="adAirlineMenu"
                      :close-on-content-click="false"
                    >
                      <template v-slot:activator="{ props }">
                        <div
                          @click="openAdvanceMenu('adAirline')"
                          class="input-styles align-center rounded-border d-flex justify-content-between"
                          v-bind="props"
                        >
                          <span class="f-size-14 fw-500 text-capitalize me-2">{{
                            $t("advancedOptions.airline")
                          }}</span>
                          <i
                            class="bi bi-caret-down-fill"
                            style="font-size: 13px; color: gray"
                            :class="{ 'rotate-icon': adAirlineMenu }"
                          ></i>
                        </div>
                      </template>
                      <v-card class="pa-3">
                        <div>
                          <v-radio-group
                            v-model="airlineSelect1"
                            inline
                            class="advanceRadio1 f-size-12"
                          >
                            <v-radio
                              value="includeAirline"
                              label="include"
                              class="me-2"
                              @click="changeSelected(airlineSelect1)"
                            ></v-radio>
                            <v-radio
                              value="excludeAirline"
                              label="exclude"
                              @click="changeSelected(airlineSelect1)"
                            ></v-radio>
                          </v-radio-group>
                        </div>
                        <div class="mt-2 mb-3">
                          <div>
                            <v-text-field
                              v-model="airlineVal"
                              placeholder="AirlineCode
                              "
                              @input="searchAirline(airlineVal)"
                              class="airlineCode"
                              dense
                              solo
                              hide-details
                              rounded-lg
                            >
                              <template v-slot:prepend-inner>
                                <v-icon icon="mdi-magnify" size="20"></v-icon>
                              </template>
                              <template v-slot:append-inner>
                                <div
                                  v-if="
                                    airlineVal && airlineList1
                                      ? airlineVal.length >= 2 &&
                                        !airlineList1.length > 0
                                      : false
                                  "
                                >
                                  <div
                                    class="spinner-border spinner-border-sm"
                                    role="status"
                                  ></div>
                                </div>
                              </template>
                            </v-text-field>
                            <v-card
                              v-if="
                                airlineList1.length > 0 && airlineVal.length > 1
                              "
                              max-height="200px"
                              class="pa-3 pt-0 overflow-auto airlineCard"
                            >
                              <div v-for="item of airlineList1" :key="item">
                                <v-checkbox
                                  v-model="selectedAirline"
                                  @change="getChange(selectedAirline)" 
                                  :value="`${item.name} - (${item.iata})`"
                                  :label="`${item.name} - (${item.iata})`"
                                  class="adcheckBox"
                                ></v-checkbox>
                              </div>
                            </v-card>
                          </div>
                        </div>
                        <v-card-actions
                          class="p-0"
                          style="min-height: fit-content"
                        >
                          <v-btn
                            color="danger"
                            height="24px"
                            class="f-size-12"
                            variant="text"
                            @click="resetAirlines()"
                            v-if="selectedAirline.length > 0"
                          >
                            <span>{{ $t("advancedOptions.resetBtn") }}</span>
                            <span><i class="fa-solid fa-rotate-right"></i></span
                          ></v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            height="24px"
                            class="f-size-12"
                            variant="text"
                            @click="adAirlineMenu = false"
                            >{{ $t("advancedOptions.doneBtn") }}</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-menu>
  </div> -->

</div>

 </div>
</div>


</template>
<script>
import axios from 'axios';
import { getConfigDataFromLocalStorage } from "@/localStorageData/localStorageUtil.js";
export default {
data(){
    return{
  adAirlineMenu: false,
          airlineSelect1: "includeAirline",
          selectedAirline: [],
      selectedAirport: [],
      airlineVal: "",
      airportVal: "",
      airlineList1: [],
      airportList: [],
      airlineApi:"",
advanceOption:[
              {
          value:false,label:"Direct Flight",valData:"0Stop"
        },
        //{
        //  value:false,label:"One Stop",valData:"1Stop"
        //},{
        //  value:false,label:"+/- 1 Days",valData:"1days"
        //},
        //{
        ////  value:false,label:"+/- 3 Days",valData:"3days"
        //},
        {
          value:true,label:"NearbyAirport",valData:"NearbyAirport"
        },
        {
          value:false,label:"Refundable Fare Only",valData:"Refundable Fare Only"
        },
      ],

    }
},
created(){
this.getConfig()
try {
  const stored = JSON.parse(sessionStorage.getItem("advanceOption") || "[]");

  if (Array.isArray(stored.advanceOption) && stored.advanceOption.length > 0) {
    this.advanceOption = stored.advanceOption;
  }
} catch (e) {
  console.error("Error parsing advanceOption from sessionStorage", e);
  this.advanceOption = [];
}

},
methods:{
getChange(selectedAirline){
console.log(selectedAirline,'selectedAirline')
this.$emit('airlineChange',selectedAirline)
},
    sentAdvance(data,index){
console.log(data,index,'adavance')
if(data.value && data.valData == "0Stop"){
this.advanceOption[index+1].value=false
}else if(data.value && data.valData == "1Stop"){
this.advanceOption[index-1].value=false
}
if(data.value && data.valData == "1days"){
this.advanceOption[index+1].value=false
}else if(data.value && data.valData == "3days"){
this.advanceOption[index-1].value=false
}
this.$emit('advanceChanged',this.advanceOption)
    },
     openAdvanceMenu(menu) {
     this.adAirlineMenu = menu === "adAirline";
    },
      resetAirlines() {
      this.airlineSelect = "includeAirline";
      this.selectedAirline = [];
      this.airlineVal = "";
      this.airlineList1 = [];
    },
   changeSelected(data) {
      if (data == "includeAirline" || data == "excludeAirline") {
        this.airlineVal = null;
        this.airlineList1 = [];
        this.selectedAirline = [];
      } else {
        this.airportVal = null;
        this.airportList = [];
        this.selectedAirport = [];
      }
    },
     async searchAirline(event) {
      if (event.length > 1) {
        await axios
          .get(`${this.airlineApi}?airlineString=${event}`, {
            headers: {
              "Content-Type": this.airlineIcaoType,
            },
          })
          .then((response) => {
            console.log(response, "responseairline");
            this.airlineList1 = response.data;
          })

          .catch((error) => {
            console.log(error, "erroroor.....");
          });
      }
    },
      getConfig() {
      const getConfigData = getConfigDataFromLocalStorage();

      if (getConfigData) {
       
        this.airlineApi = getConfigData.payload.portal_configuration.API_endpoints.airline_autocomplete;
       
      }
    },
    
}


}

</script>

<style scoped>

.dropdownSection .input-styles {
  height: auto;
  padding: 5px 7px;
  background-color: #f5faff; 
  color:black;
  border-radius: 0.5rem;
}:deep( .dropdownSection .v-select .v-field__input) {
  padding: 0 !important;
  min-height: 30px;
}
:deep(.adcheckBox  .v-input__control .v-label ){
  color: black !important;
}
:deep(.adcheckBox .v-input__control ){
    height: 20px !important;
}

:deep(.dropdownSection .v-field__append-inner) {
  padding: 0px !important;
}

:deep(.dropdownSection .v-selection-control__wrapper) {
  height: 20px;
}

:deep(.dropdownSection .v-select input::placeholder) {
  font-size: 14px;
  font-weight: 500;
  color: #767676;
  opacity: 1;
  height: 20px;
}
.dropdownSection .input-styles .v-btn {
  height: 30px;
}
:deep(.advanceCheckbox .v-input__details) {
    display: none !important;
  }
  :deep(.advanceCheckbox .v-input__control ){
    display: flex;
    grid-area: control;
    height: 32px  !important;
}
:deep(.advanceCheckbox .v-selection-control .v-label) {
    white-space: normal;
    word-break: break-word;
    height: 100%;
    font-size: 14px;
    font-weight: 600;
}
:deep(.v-switch__thumb ){
    height: 15px;
    width: 15px;}
	
	:deep(.v-switch__track) {
    height: 11px;
    background-color: rgb(255 255 255);
    min-width:28px;
  }
    :deep(.v-selection-control .v-label) {
    font-size: 12px;
    font-weight:500;
    color:#ffffff;
}

:deep(.advanceRadio1.v-radio-group .v-selection-control--density-default) {
  --v-selection-control-size: 24px !important;
}

:deep(.advanceRadio1.v-radio-group .v-label) {
  font-size: 14px;
  font-weight: 500;
}
:deep(.advanceRadio1.v-radio-group .v-label) {
  color:black
}
:deep(.airlineCode .v-field) {
  padding: 0 6px;
}
:deep(.airlineCode .v-field__input) {
  min-height: 30px;
  padding: 0 6px;
  font-size: 14px;
  font-weight: 500;
}
:deep(.adcheckBox .v-selection-control--density-default) {
  --v-selection-control-size: 30px !important;
}


:deep(.adcheckBox .v-selection-control__input > .v-icon) {
  font-size: 18px !important;
}

:deep(.adcheckBox .v-input__control .v-label) {
  font-size: 14px;
  font-weight: 500;
}
:deep(.advancedData .v-input--density-default){
  --v-input-control-height:30px;
}
:deep(.advancedData .v-input .v-input__details){
  display:none;
}
</style>